import { configureStore } from "@reduxjs/toolkit";
import gameSlice from "./gameSlice";
import scratchSlice from "./scratchSlice";

export const store = configureStore({
    reducer: {
        game:gameSlice,
        scratch:scratchSlice
    },
});